import { GET_INNSYN_PERSONOPPLYSNINGER } from "../actions/personopplysningerActions";

const INITIAL_STATE = {
  result: null,
  noResult: false,
  hasBeenSubmitted: false,
};

const innsynPersonopplysningerReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case `${GET_INNSYN_PERSONOPPLYSNINGER}_SUCCESS`:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default innsynPersonopplysningerReducer;
